/**
 * SQ Reviews Summary — Carousel
 *
 * Desktop (≥1024px): 3 cards visible, translateX-based slide, arrows + dots +
 *   keyboard nav + pointer drag. Matches sq-before-after.js pattern.
 * Mobile/tablet (<1024px): native scroll-snap handles swipe. JS only syncs dot
 *   indicators from scroll position. No pointer listeners on mobile.
 * Truncation: "ler mais" shown only when review text overflows.
 */
(function () {
  function init() {
    var root = document.querySelector('.sq-reviews-summary');
    if (!root) return;

    var wrap = root.querySelector('.reviews-carousel-wrap');
    if (!wrap) return;
    var viewport = root.querySelector('.reviews-viewport');
    if (!viewport) return;
    var track = root.querySelector('.reviews-track');
    if (!track) return;
    var cards = Array.from(track.querySelectorAll('.review-card'));
    var n = cards.length;
    if (n < 2) return;

    var mql = window.matchMedia('(min-width: 1024px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;

    // ── Arrows (desktop only, CSS hides on mobile) ──
    // Inserted as direct children of wrap, outside viewport overflow
    var prevBtn = createArrow('prev', 'Avaliação anterior');
    var nextBtn = createArrow('next', 'Próxima avaliação');
    wrap.insertBefore(prevBtn, viewport);
    wrap.appendChild(nextBtn);

    function createArrow(dir, label) {
      var btn = document.createElement('button');
      btn.className = 'reviews-arrow reviews-arrow--' + dir;
      btn.setAttribute('aria-label', label);
      btn.setAttribute('type', 'button');
      btn.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';
      return btn;
    }

    prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; update(true); }
    });
    nextBtn.addEventListener('click', function () {
      if (current < maxIndex()) { current++; update(true); }
    });

    // ── Dots ──
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'reviews-dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Avaliações');
    var dots = [];
    for (var i = 0; i < n; i++) {
      var dot = document.createElement('button');
      dot.className = 'reviews-dot';
      dot.setAttribute('type', 'button');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Avaliação ' + (i + 1) + ' de ' + n);
      // Click handler only fires on desktop (CSS pointer-events: none on mobile)
      dot.addEventListener('click', (function (idx) {
        return function () { current = idx; update(true); };
      })(i));
      dots.push(dot);
      dotsWrap.appendChild(dot);
    }
    wrap.appendChild(dotsWrap);

    function updateDots(activeIdx) {
      dots.forEach(function (d, idx) {
        var active = idx === activeIdx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    // ── Shared helpers ──
    function visibleCount() {
      return mql.matches ? 3 : 1;
    }

    function maxIndex() {
      return Math.max(0, n - visibleCount());
    }

    function clamp(val) {
      return Math.max(0, Math.min(val, maxIndex()));
    }

    function getStep() {
      var cardW = cards[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return { cardW: cardW, gap: gap, step: cardW + gap };
    }

    // ── Desktop update: translateX positioning ──
    function update(animate) {
      if (!mql.matches) {
        // Mobile: clear desktop state, native scroll handles positioning
        track.style.transform = '';
        track.style.transition = '';
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }

      current = clamp(current);
      var m = getStep();
      var offset = -(current * m.step);

      if (animate && !reducedMotion.matches) {
        track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(' + offset + 'px)';

      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= maxIndex();

      updateDots(current);
    }

    // ── Desktop keyboard navigation ──
    wrap.setAttribute('tabindex', '0');
    wrap.addEventListener('keydown', function (e) {
      if (!mql.matches) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (current > 0) { current--; update(true); }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (current < maxIndex()) { current++; update(true); }
      }
    });

    // ── Desktop pointer drag (attach/detach on breakpoint, matches B&A) ──
    var dragStartX = 0;
    var trackStartX = 0;
    var dragging = false;
    var SWIPE_THRESHOLD = 50;

    function onPointerDown(e) {
      // Don't start drag when clicking links or buttons (ler mais, arrows, dots)
      if (e.target.closest('a, button')) return;
      dragging = true;
      dragStartX = e.clientX;
      var matrix = getComputedStyle(track).transform;
      if (matrix && matrix !== 'none') {
        trackStartX = parseFloat(matrix.split(',')[4]) || 0;
      } else {
        trackStartX = 0;
      }
      track.setPointerCapture(e.pointerId);
      track.style.transition = 'none';
      track.style.cursor = 'grabbing';
    }

    function onPointerMove(e) {
      if (!dragging) return;
      e.preventDefault();
      var delta = e.clientX - dragStartX;
      track.style.transform = 'translateX(' + (trackStartX + delta) + 'px)';
    }

    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = '';
      var delta = e.clientX - dragStartX;
      if (Math.abs(delta) >= SWIPE_THRESHOLD) {
        if (delta < 0 && current < maxIndex()) current++;
        else if (delta > 0 && current > 0) current--;
      }
      update(true);
    }

    function onPointerCancel() {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = '';
      update(true);
    }

    function attachDrag() {
      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerCancel);
    }

    function detachDrag() {
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', onPointerUp);
      track.removeEventListener('pointercancel', onPointerCancel);
      dragging = false;
      track.style.cursor = '';
    }

    // ── Mobile scroll listener: sync dots from native scroll position ──
    var scrollTimer;
    function onTrackScroll() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var m = getStep();
        var idx = Math.round(track.scrollLeft / m.step);
        idx = Math.max(0, Math.min(idx, n - 1));
        updateDots(idx);
      }, 60);
    }

    track.addEventListener('scroll', onTrackScroll);

    // ── Breakpoint handling ──
    if (mql.matches) attachDrag();

    mql.addEventListener('change', function () {
      if (mql.matches) {
        attachDrag();
      } else {
        detachDrag();
      }
      current = clamp(current);
      update(false);
      checkTruncation();
    });

    // ── Truncation — inline "ler mais / ler menos" via word-trim ──
    var textEls = Array.from(track.querySelectorAll('.review-text'));

    function truncateEl(el, card) {
      if (card.classList.contains('is-expanded')) return;

      var fullText = el.dataset.fullText;
      if (!fullText) {
        fullText = el.textContent.trim();
        el.dataset.fullText = fullText;
      }

      while (el.firstChild) el.removeChild(el.firstChild);
      el.style.display = 'block';
      el.style.maxHeight = 'none';
      el.textContent = fullText;

      var lineH = parseFloat(getComputedStyle(el).lineHeight);
      var maxH = Math.ceil(lineH * 5);

      if (el.scrollHeight <= maxH + 1) {
        card.classList.remove('is-truncated');
        el.style.display = '';
        el.style.maxHeight = '';
        return;
      }

      card.classList.add('is-truncated');

      var words = fullText.split(/\s+/);
      var textNode = document.createTextNode('');
      var btn = document.createElement('button');
      btn.className = 'review-read-more';
      btn.type = 'button';
      btn.textContent = 'ler mais';
      btn.setAttribute('aria-expanded', 'false');

      while (el.firstChild) el.removeChild(el.firstChild);
      el.appendChild(textNode);
      el.appendChild(btn);

      var lo = 1, hi = words.length - 1;
      while (lo < hi) {
        var mid = Math.ceil((lo + hi) / 2);
        textNode.textContent = words.slice(0, mid).join(' ') + '… ';
        if (el.scrollHeight <= maxH + 1) {
          lo = mid;
        } else {
          hi = mid - 1;
        }
      }

      textNode.textContent = words.slice(0, lo).join(' ') + '… ';
      el.style.maxHeight = maxH + 'px';
    }

    function checkTruncation() {
      textEls.forEach(function (el) {
        var card = el.closest('.review-card');
        if (card) truncateEl(el, card);
      });
    }

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.review-read-more');
      if (!btn) return;
      var card = btn.closest('.review-card');
      if (!card) return;
      var textEl = card.querySelector('.review-text');
      if (!textEl) return;

      var expanding = !card.classList.contains('is-expanded');

      if (expanding) {
        card.classList.add('is-expanded');
        var fullText = textEl.dataset.fullText || '';
        while (textEl.firstChild) textEl.removeChild(textEl.firstChild);
        textEl.appendChild(document.createTextNode(fullText + ' '));
        var newBtn = document.createElement('button');
        newBtn.className = 'review-read-more';
        newBtn.type = 'button';
        newBtn.textContent = 'ler menos';
        newBtn.setAttribute('aria-expanded', 'true');
        textEl.appendChild(newBtn);
        textEl.style.maxHeight = '';
      } else {
        card.classList.remove('is-expanded');
        truncateEl(textEl, card);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        update(false);
        checkTruncation();
      }, 150);
    });

    // ── Init ──
    update(false);
    updateDots(0);
    checkTruncation();

    // Re-check after web fonts finish loading (dimensions may change)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        checkTruncation();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
